module.exports = __webpack_public_path__ + "img/hero_right_artwork.0a6c4539.png";